import { createSelector } from "reselect";
import orderByName from "../utils/orderByName";

export const getThemes = (state) => state.entities.themes;

export const getAllThemes = createSelector(getThemes, (themes) =>
  Object.values(themes).sort(orderByName)
);
